import { bootstrap } from './core';
import { ToogleClassOnClick } from './directives/toggle-class-on-click.directive';
import { AddBackLink } from './directives/add-back-link-submenu.directive';
import { MenuCloserDirective } from './directives/menu-closer.directive';
import { MenuItemHasChildren } from './directives/menu-item-has-children.directive';

window.App = bootstrap([
    ToogleClassOnClick,
    AddBackLink,
    MenuCloserDirective,
    MenuItemHasChildren
]);
console.log(window.App);


// WEBPACK FOOTER //
// ./src/js/app.js